
'use strict'

import App from "../../App";

export const TYPE_GRID_VIEW = 'TYPE_GRID_VIEW';
export const TYPE_LIST_VIEW = 'TYPE_LIST_VIEW';

export class OurTeamMember{
    constructor(data, viewType, animIndex){
        this.main = null
        this._data = data;
        this._animIndex = animIndex;

        this.setViewType(viewType);
    }

    setViewType(viewType){
        let newMain = document.createElement('div');

        if(viewType == TYPE_GRID_VIEW){
            newMain.innerHTML = /*html*/ `<div class="col-sm-6 col-md-4 col-xl-3 GRID">
                                            <a href="${App.baseUrl + App.sitemap.our_team_detail.slug + this._data.slug}" class="card-photo card-photo--professional card-photo--effect-1 wow fadeIn" data-wow-delay="0.${this._animIndex}s">
                                                <div class="card-photo__thumb">
                                                    <div class="bg">
                                                        <div class="bg__img" style="background-image: url('${App.filesPath + this._data.image}?version=${App.version}');"></div>				
                                                    </div>
                                                </div>
                                                
                                                <div class="card-photo__content">
                                                    <div class="card-photo__sub">${this._data.position}</div>
                                                    <div class="card-photo__title">${this._data.name}</div>
                                                </div>
                                            </a>
                                        </div>`;
        }else{
            newMain.innerHTML =  /*html*/`<div class="col-md-6 LIST">
                                        <a href="${App.baseUrl + App.sitemap.our_team_detail.slug + this._data.slug}" class="card-photo card-photo--professional-list wow fadeIn" data-wow-delay="0.${this._animIndex}s">
                                            <div class="row">
                                                <div class="col-5 col-lg-4 col--photo">
                                                    <div class="card-photo__thumb">
                                                        <div class="bg">
                                                            <div class="bg__img" style="background-image: url('${App.filesPath + this._data.image}');"></div>				
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-7 col-lg-8">
                                                    <div class="card-photo__content">
                                                        <div class="card-photo__sub">${this._data.position}</div>
                                                        <div class="card-photo__title">${this._data.name}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>`;            
            
        }
        
        
        newMain = newMain.firstChild; 

        if(this.main != null){
            this.main.parentNode.replaceChild(newMain, this.main);
            this.main = newMain;
        }else{
            this.main = newMain;
        }
    }
}

